import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from './context/LanguageContext';
import { Header } from './components/Header';
import { BackToTop } from './components/BackToTop';
import { ScrollToTop } from './components/ScrollToTop';
import { Home } from './pages/Home';
import { AboutBreed } from './pages/AboutBreed';
import { OurCats } from './pages/OurCats';
import { Cattery } from './pages/Cattery';
import { Contact } from './pages/Contact';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutBreed />} />
            <Route path="/cats" element={<OurCats />} />
            <Route path="/cattery" element={<Cattery />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <BackToTop />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;